<template>
  <v-card>
    <v-card-title class="d-flex">
      <h2 class="dialog-title">Which option is right for me?</h2>
      <v-btn icon class="btn-close" aria-label="Close" @click="hideModal">
        <img src="@/assets/icons/ic_close.svg" />
      </v-btn>
    </v-card-title>
    <v-divider></v-divider>

    <v-card-text>
      <v-col cols="12" v-if="isDownloadError" ref="downloadError">
        <v-alert
          dense
          text
          type="error"
          icon="mdi-alert-circle"
          class="ma-0 flex-grow-1 rounded-lg"
        >
          <span class="black--text">
            <strong>Sorry! </strong> Document could not be downloaded at this
            time.
          </span>
        </v-alert>
      </v-col>
      <p>
        You can choose to insure just your buildings or add cover for any
        belongings inside the property that you'd like to protect. We also offer
        a range of optional extras allowing you to tailor your insurance to meet
        your needs.
      </p>

      <p class="font-weight-bold mb-1">Buildings Insurance</p>
      <p>
        Buildings Insurance covers damage to the buildings (and outbuildings
        within 100m) of your property including landlord’s fixtures and
        fittings, patios, terraces, footpaths, swimming pools, tennis courts,
        drives, walls, fences and gates.
      </p>
      <p>Examples of what’s <span class="important-text">not</span> covered:</p>
      <ul>
        <li>The costs of routine maintenance.</li>
        <li>
          Loss or damage to fences, hedges and gates caused by storm or flood.
        </li>
        <li>
          Loss or damage caused by or from poor workmanship, poor design or
          faulty materials.
        </li>
      </ul>

      <p class="font-weight-bold mb-1">Contents Insurance</p>
      <p>
        Contents insurance covers damage to domestic furniture and furnishings
        which belong to you and are in the insured property including
        televisions, satellite and radio receiving aerials, fridges, freezers,
        washing machines, tumble driers, dishwashers, microwaves, gas and
        electric cookers and meters.
      </p>
      <p>
        Examples of what’s
        <span class="important-text">not</span> covered:
      </p>
      <ul>
        <li>
          Motorized or mechanically propelled or assisted vehicles (other than
          garden machinery and motorized or electric wheelchairs).
        </li>
        <li>
          Items of precious metal or precious stones such as jewelry and
          watches.
        </li>
        <li>Computer equipment or portable electrical equipment.</li>
      </ul>
      <p>
        For full details of what's covered and what's not covered under
        Buildings & Contents Insurance, please read our
        <span class="download-link" @click="downloadFile(policyBookletDocument)"
          >Landlord's Insurance Policy Booklet</span
        >.
      </p>
    </v-card-text>
  </v-card>
</template>
<script>
import { DIALOG_MODULE } from "@/store/types/module-types";
import { mapGetters, mapMutations } from "vuex";
import documentService from "@/services/document.service";
import { QUESTIONS_MODULE } from "@/store/types/module-types";
import { LANDLORD_POLICY_DOCUMENT } from "@/constants/d2c-landing-page.constants.js";
import { PRODUCT } from "@/constants/common.constants";
import { downloadDocument, getLatestStaticDocuments } from "@/common/utils";
export default {
  name: `DialogContentCoverType`,
  data() {
    return {
      isDownloadError: false,
      staticDocumentData: [],
    };
  },
  mounted() {
    this.getStaticDocuments();
  },
  computed: {
    ...mapGetters(QUESTIONS_MODULE, ["httpConfig"]),
    policyBookletDocument() {
      return this.staticDocumentData?.find((doc) => doc.code === "terms");
    },
  },
  methods: {
    ...mapMutations(DIALOG_MODULE, [`hideModal`]),
    async downloadFile(file) {
      this.isDownloadError = false;
      try {
        const doc = await documentService.getDocument(
          file.Link,
          this.httpConfig
        );
        downloadDocument(doc, file.fileName);
      } catch (e) {
        this.isDownloadError = true;
        setTimeout(() => {
          const el = this.$refs.downloadError;
          const yourHeight = 80; //heigh of float header panel
          // scroll to your element
          if (el) {
            el.scrollIntoView(true);
          }
          // now account for fixed header
          const scrolledY = window.scrollY;
          if (scrolledY) {
            window.scroll(0, scrolledY - yourHeight);
          }
        }, 500);
        console.error(e);
      }
    },
    async getStaticDocuments() {
      try {
        this.staticDocumentData = await getLatestStaticDocuments(
          PRODUCT.LandLord,
          LANDLORD_POLICY_DOCUMENT
        );
      } catch (error) {
        this.isDownloadError = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.important-text {
  text-decoration: underline;
  font-weight: bold;
}
.download-link {
  text-decoration: underline;
  cursor: pointer;
}
</style>
